/* Homebod' theme.js */
(function () {
  "use strict";

  /* ---------- light switch ---------- */
  var root = document.documentElement;
  var cord = document.getElementById("cord");
  if (cord) {
    var tip = document.getElementById("tip");
    var swap = document.getElementById("swap");
    function setLights(state, announce) {
      root.dataset.lights = state;
      var on = state === "on";
      cord.setAttribute("aria-pressed", on);
      cord.setAttribute("aria-label", on ? "Turn the big light off" : "Turn the big light on");
      if (tip) tip.textContent = on ? "pull to turn it back off" : "pull to turn the big light on";
      if (swap) swap.textContent = on ? swap.dataset.on : swap.dataset.off;
      if (on && announce && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
        document.body.classList.remove("flicker");
        void document.body.offsetWidth;
        document.body.classList.add("flicker");
      }
      try { localStorage.setItem("homebod-lights", state); } catch (e) {}
    }
    cord.addEventListener("click", function () {
      setLights(root.dataset.lights === "on" ? "off" : "on", true);
    });
    try {
      var saved = localStorage.getItem("homebod-lights");
      if (saved === "on") setLights("on", false);
    } catch (e) {}
  }

  /* ---------- mood compare slider ---------- */
  var cmp = document.getElementById("compare");
  if (cmp) {
    var warm = document.getElementById("warm");
    var handle = document.getElementById("handle");
    var dragging = false;
    function split(pct) {
      pct = Math.max(0, Math.min(100, pct));
      warm.style.setProperty("--split", pct + "%");
      handle.style.left = pct + "%";
      cmp.setAttribute("aria-valuenow", Math.round(pct));
    }
    function fromEvent(e) {
      var r = cmp.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      split((x / r.width) * 100);
    }
    cmp.addEventListener("pointerdown", function (e) { dragging = true; cmp.setPointerCapture(e.pointerId); fromEvent(e); });
    cmp.addEventListener("pointermove", function (e) { if (dragging) fromEvent(e); });
    cmp.addEventListener("pointerup", function () { dragging = false; });
    cmp.addEventListener("keydown", function (e) {
      var now = +cmp.getAttribute("aria-valuenow");
      if (e.key === "ArrowLeft") { split(now - 5); e.preventDefault(); }
      if (e.key === "ArrowRight") { split(now + 5); e.preventDefault(); }
    });
    split(+cmp.dataset.initial || 55);
  }

  /* ---------- newsletter ---------- */
  var join = document.getElementById("join");
  if (join) {
    join.addEventListener("submit", function (e) {
      var msg = document.getElementById("msg");
      var email = document.getElementById("email");
      if (!email.checkValidity()) {
        e.preventDefault();
        if (msg) msg.textContent = "That email doesn't look right — check it and try again.";
        return;
      }
      if (msg) msg.textContent = "Submitting…";
    });
  }

  /* ---------- mobile menu ---------- */
  var menuToggle = document.querySelector(".menu-toggle");
  var mobileMenu = document.getElementById("mobile-menu-drawer");
  var mobileOverlay = document.querySelector(".mobile-menu-overlay");
  var mobileClosers = document.querySelectorAll("[data-mobile-menu-close]");
  function setMobileMenu(open) {
    if (!menuToggle || !mobileMenu) return;
    mobileMenu.classList.toggle("is-open", open);
    if (mobileOverlay) mobileOverlay.classList.toggle("is-open", open);
    mobileMenu.setAttribute("aria-hidden", open ? "false" : "true");
    menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.classList.toggle("mobile-menu-open", open);
  }
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", function () { setMobileMenu(true); });
    mobileClosers.forEach(function (el) { el.addEventListener("click", function () { setMobileMenu(false); }); });
    mobileMenu.querySelectorAll("a").forEach(function (link) { link.addEventListener("click", function () { setMobileMenu(false); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") setMobileMenu(false); });
  }

  /* ---------- cart drawer (Shopify AJAX Cart API) ---------- */
  var drawer = document.getElementById("cart-drawer");
  var overlay = document.getElementById("cart-overlay");
  var itemsEl = document.getElementById("cart-items");
  var subtotalEl = document.getElementById("cart-subtotal-amount");
  var countEls = document.querySelectorAll("[data-cart-count]");

  function moneyFormat(cents) {
    return (window.Shopify && window.Shopify.formatMoney)
      ? window.Shopify.formatMoney(cents, window.theme_money_format)
      : "R " + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    if (!itemsEl) return;
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-empty">Your cart is quietly waiting for some glow.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item) {
        return (
          '<div class="cart-line" data-key="' + item.key + '">' +
            (item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy">' : "") +
            '<div class="ci-info">' +
              '<div class="ci-title">' + item.product_title + "</div>" +
              (item.variant_title ? '<div class="ci-var">' + item.variant_title + "</div>" : "") +
              '<div class="ci-row">' +
                '<div class="qty">' +
                  '<button type="button" data-qty-decrease>−</button>' +
                  "<span>" + item.quantity + "</span>" +
                  '<button type="button" data-qty-increase>+</button>' +
                "</div>" +
                '<span>' + moneyFormat(item.final_line_price) + "</span>" +
              "</div>" +
              '<button type="button" class="ci-remove" data-remove>Remove</button>' +
            "</div>" +
          "</div>"
        );
      }).join("");
    }
    if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
  }

  function fetchCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    overlay.classList.add("is-open");
    drawer.removeAttribute("aria-hidden");
    fetchCart();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
  }

  document.querySelectorAll("[data-cart-open]").forEach(function (btn) {
    btn.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (btn) {
    btn.addEventListener("click", closeDrawer);
  });
  if (overlay) overlay.addEventListener("click", closeDrawer);

  if (itemsEl) {
    itemsEl.addEventListener("click", function (e) {
      var line = e.target.closest(".cart-line");
      if (!line) return;
      var key = line.dataset.key;

      if (e.target.matches("[data-remove]")) {
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 }),
        }).then(function (r) { return r.json(); }).then(renderCart);
      }
      if (e.target.matches("[data-qty-increase],[data-qty-decrease]")) {
        var span = line.querySelector(".qty span");
        var qty = parseInt(span.textContent, 10);
        qty = e.target.matches("[data-qty-increase]") ? qty + 1 : Math.max(0, qty - 1);
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: qty }),
        }).then(function (r) { return r.json(); }).then(renderCart);
      }
    });
  }

  /* Add-to-cart forms (product card quick-add + product page form) */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches('[data-add-to-cart-form], .product-form')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : "";
    if (btn) btn.textContent = "Adding…";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Object.fromEntries(new FormData(form))),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) btn.textContent = "Added";
        openDrawer();
        setTimeout(function () { if (btn) btn.textContent = original; }, 1500);
      })
      .catch(function () {
        if (btn) btn.textContent = "Try again";
        setTimeout(function () { if (btn) btn.textContent = original; }, 1500);
      });
  });

  if (drawer) fetchCart();
})();

/* ---------- Homebod v11 review carousel ---------- */
document.querySelectorAll('.reviews-section').forEach(function (section) {
  var track = section.querySelector('[data-review-track]');
  var prev = section.querySelector('[data-review-prev]');
  var next = section.querySelector('[data-review-next]');
  if (!track) return;
  function step() {
    var card = track.querySelector('.review-card');
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).gap) || 16;
    return card.getBoundingClientRect().width + gap;
  }
  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
});

/* ---------- Homebod v11 product gallery ---------- */
document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
  var main = gallery.querySelector('[data-product-main-image]');
  gallery.querySelectorAll('[data-product-thumb]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (!main) return;
      main.src = button.dataset.image;
      main.srcset = '';
      gallery.querySelectorAll('[data-product-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
      button.classList.add('is-active');
    });
  });
});

document.querySelectorAll('[data-homebod-quiz]').forEach(function(form){form.addEventListener('submit',function(e){e.preventDefault();if(!form.reportValidity())return;var score=0;new FormData(form).forEach(function(v){score+=Number(v);});var result=form.querySelector('[data-quiz-result]');result.textContent=score>=5?'Homebod Pro Max — homebodmaxxing. Staying in is your lifestyle.':score>=2?'Homebod’ Mid — you have plans later / this weekend, don’t you?':'You outside — why are you even filling this out if you’re not at home?';result.focus();});});
